import React, { useContext, useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { UserContext } from './utils';

const ProtectedRoute = ({ children }) => {
  const { user } = useContext(UserContext);
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setIsAuthenticated(false);
    } else {
      setIsAuthenticated(true);
    }
  }, []);

  if (isAuthenticated === null) {
    // Optional: Show loading spinner while checking authentication
    return <div>Loading...</div>;
  }

  if (!isAuthenticated || !user.userId) {
    // Redirect to sign-up page, preserving the attempted path for redirection after login
    return (
      <Navigate
        to="/sign-up"
        state={{
          from: location.pathname,
          redirectAfterLogin: location.pathname,
        }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
